import React from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

import { generateRedux } from "components/InfinityTable/Redux"
import { set as setAddressModal } from "containers/AddressModal/actions"
import saga from "./saga"
import AddressBookList from "components/AddressBookList"

export const redux = generateRedux({
  id: "containers/AddressBookOrder/",
  url: "/api/addressbook/list/infinity",
  initialState: {
    sortableColumns: ["id"]
  },
  sagas: [saga]
})

const connectRedux = connect(
  createStructuredSelector({
    ...redux.structuredSelector
    // additional selectors here
  }),
  {
    ...redux.actions,
    setAddressModal
  }
)

const AddressBookOrder = props => {
  return <AddressBookList {...props} />
}

export default connectRedux(AddressBookOrder)
